import React from "react";
import styled from 'styled-components'
import Header from '@/components/Header'
import bridge from '@/config/JSbridge'

const Activity230Rules = () => {

  const handleLeftClick = () => {

    bridge.callHandler('nativeEvent', {event: 'close', params: {
      isDelete: false
    }}, () => {})
  }

  return (
    <Container>
      <Header
        title={'活动规则'}
        leftClick={()=> {
          handleLeftClick()
        }}
      />
      <div className="content">
        <div>参与【每日发帖抽红包】活动（以下简称“本活动”）前，请用户详细阅读活动规则及相关条款。凡参与本次活动，则视为用户已阅读、理解并同意活动规则全部内容。</div>
        <div className="title">一、活动时间</div>
        <div>本活动为“限时开启”，自2026年5月15日开启后，视活动情况或活动不抵抗力，可随时终止活动。</div>
        <div className="title">二、活动参与资格：</div>
        <div>本活动的参与者（以下简称“您”或“用户”）应具备以下全部资格：</div>
        <div>1.您应为具备完全民事行为能力的自然人。</div>
        <div>2.您需为市值风云App活跃用户（30天内超7天以上登录账号使用过App）。</div>
        <div>3.活动期间，每个自然人仅可以使用一个自己合法有权的有效市值风云账号参与本活动，如"违规"使用自己名下多个账号或使用他人账号，您的全部参与行为将被视为无效，且无权获得任何奖品。</div>
        <div>4.本活动仅支持市值风云APP版本号6.54及以上的版本，6.54以下版本需升级App版本后参与。</div>
        <div className="title">三、活动玩法与抽奖次数</div>
        <div>在活动期间，您通过活动提示指引完成对应的发帖任务，当帖子发布后即可获得抽奖次数；同时在活动页面点击抽奖按钮消耗抽奖次数进行抽奖，完成抽奖后抽奖结果即时显示。</div>
        <div className="sub-title">1.抽奖次数获取：</div>
        <div>每人每天最多可获得2次抽奖次数，获得方式只能通过发活动帖完成：在发帖页显示“发帖可获得抽红包次数”指引提示时（需将App更新至最新版），根据指引提示输入相应内容，当指引提示显示“发布后可获得抽奖次数”时，对帖子完成发布后即可获得提示所得的抽奖次数，获得的抽奖次数可在本活动进行抽奖。</div>
        <div className="sub-title">2.收回抽奖次数：</div>
        <div>当发帖获得抽奖次数后，抽奖次数会立即发放到账户中；发布的帖子因被删除（自行删除或被管理员删除）或被系统判定为“水帖或其他不满足条件时”即会被收回帖子所获得的抽奖次数。</div>
        <div>注：只有参与本活动，获得抽奖次数的所发布的帖子被删或被判定为水帖才会收回对应抽奖次数，其他正常发布的帖子进行删除不会触发抽奖次数扣除。</div>
        <div className="sub-title">3.抽奖与奖项：</div>
        <div>1）当获得抽奖次数后即可在本活动页面消耗所获得的抽奖次数进行抽奖，抽奖设置3大类共6项奖品：</div>
        <div>①现金红包类</div>
        <div>· 现金红包：抽奖获得“现金红包”，通过拆开红包获得红包金额，金额随机（0.18-1.88元）；获得金额后会累计到本活动的红包账户中，可操作提取到市值风云创作收益账户。</div>
        <div>· 大红包：抽奖获得“大红包”，通过拆开红包获得红包金额，金额随机（38.88-88.88元）；获得金额后会累计到本活动的红包账户中，可操作提取到市值风云创作收益账户。</div>
        <div>②会员类</div>
        <div>两个会员类奖项，奖项为市值风云-风云VIP天数，抽奖获得的会员天数会立即下发充值到您的市值风云账号中。</div>
        <div>③积分类</div>
        <div>两个积分类奖项，积分为市值风云积分（可在市值风云APP-我的-积分中心查看），抽奖获得的积分会立即下发到您的市值风云账号中。</div>
        <div>以上所有奖项会即时发放，但如遇服务器等不可控因素波动可能会造成奖励发放推迟，如超1小时还未收到抽奖奖品可在APP-客服页进行咨询。</div>
        <div>2）必得“大红包”玩法：提高大红包奖项的中奖概率，增加“累计抽奖达99次，保底必中大红包”玩法。</div>
        <div>累计抽奖次数会在每次参与抽奖后累加，当累计抽奖次数达到98次后，还未抽取到奖池中的大红包时，再进行1次抽奖（完成第99次抽奖）必得“大红包”奖项。</div>
        <div>· 累计次数清零：抽取到“大红包”奖品后，累计抽奖次数将被清零；</div>
        <div>· 累计次数衰减：当累计抽奖次数超过20次后，近5天未再参与抽奖时，累计抽奖次数将减少2次。</div>
        <div className="sub-title">4.现金红包提取</div>
        <div>1）现金红包有效期：抽奖所获得的现金红包奖励都会临时存放到本活动红包账户中，存放的临时有效期为30天，当超30天未操作将现金红包提取到市值风云创作收益账户，将视为您放弃该项奖励：对所得的现金红包进行过期清零处理（提取到市值风云创作收益账户后就不存在本活动有效期限制）。</div>
        <div>2）提取到市值风云创作收益账户需必须满足以下2点条件：</div>
        <div>· 提取的市值风云账号必须完成实名认证并开通赞赏功能。</div>
        <div>· 提取时本活动红包账户余额累计满1.00元。</div>
        <div className="title">四、活动参与内容要求</div>
        <div>1.本平台鼓励原创内容，参与活动的用户应当保证在参与本活动时发布的帖子均为本人原创，且此前未发布在本活动平台或其他第三方平台。本平台有权要求作者提供完整的内容权属说明。如发现参与活动的内容为搬运、抄袭等非原创内容，有权下限删除相应内容，并收回所发放的抽奖次数或直接取消内容作者参与活动的资格。</div>
        <div>2.投稿内容不得发表无意义或偏离主题的灌水内容，包括但不限于：纯表情、纯数字、纯符号、乱码、重复字符堆砌、或与股票、金融、投资等社区核心主题无关内容。平台一经发现，有权采取措施，包括但不限于：收回抽奖次数、取消活动资格、限制账号功能等。</div>
        <div>3.投稿内容不得违反国家法律法规、政策规章、平台规范及公序良俗；不得侵犯任何第三方的知识产权和其他合法权益，不得发布打色情低俗擦边球、标题党、封面党的内容；不得发布包含个股推荐及买卖建议；不得存在其他违反《市值风云用户协议》、《市值风云用户社区规则》等相关平台规则的行为；如平台发现用户通过不正当行为参与本活动，如恶意解读活动规则、恶意投稿与活动规则无关的内容、故意刷量、展示和诱导其他用户骗取点击互动等，以获取活动奖励，平台一经发现，有权采取措施，包括但不限于：降低活动奖励、限制提现、账号金额清零、撤销活动资格、限制登录、封禁账号、限制再次注册使用等措施，亦有权收回用户已领取的奖励、追讨已提现的金额，并保留追究该用户责任的权利。</div>
        <div>4.参与人保证对于上传的内容、要素享有全部合法权利，不侵犯任何第三方合法权益，并有权用于参与本活动，否则，造成的一切后果及损失由参与人承担。</div>
        <div className="title">五、法律声明</div>
        <div>1.如你为未成年人用户，请务必在监护人的陪同及指导下认真阅读并充分理解活动规则，并委托监护人或在监护人的明示同意下参与活动，否则请勿参与本活动。</div>
        <div>2.参与人 / 获奖者已上传参与本活动的作品未经主办方同意不得删除、下架。</div>
        <div>3.用户不得以任何不正当手段及舞弊行为参与本活动，一经发现，平台有权采取限制登录、限制参与活动、封禁账号、撤消活动资格、限制提现、账号金额清零、回收账户抽奖次数、限制领取礼品 / 卡券等措施，亦有权收回用户已领取的红包及已领取的积分 / 会员卡券、追讨已提现的金额或与奖品同等价值的金额，并保留追究用户责任的权利。如因此给用户造成损失，平台不进行任何赔偿或补偿。</div>
        <div>a.不正当手段及舞弊行为包括但不限于：下载非官方客户端；使用模拟器、插件、外挂等非法工具扫码、下载、安装、注册、登录、赠与、领取红包、提现、参与活动，冒充领取奖品；注册多个账号；篡改设备数据；买卖账号、买卖卡片牟利扰乱平台秩序；作弊非法获利；使用插件、外挂、系统或第三方工具对平台及本活动进行干扰、破坏、修改或施加其他影响、违反诚实信用原则及平台认为的其他不正当手段。</div>
        <div>4.同一个登录账号、同一个手机号或同一提现账户等与用户身份相关的信息，其中任意一项或数项存在相同、相似、通过特定标记形成批量信息、或其他非真实有效等情形的，都视为同一个用户，在本活动规则中按同一用户处理。</div>
        <div>5.主办方依法运营此次活动，如因不可抗力、情势变更、相关政策变动、政府机关指令要求、活动参与人数不足、第三方原因等非主办方原因导致本次活动调整、暂停举办、无法进行、用户参与失败的，主办方有权随时决定修改、暂停、取消或终止本活动，并无需为此承担任何法律责任。用户自身原因导致参与失败的，不利后果由用户自行承担。用户可在本页面随时查看修改后的活动规则，若用户对修改后的活动规则有异议的，请停止继续参与，若用户继续参加本活动，则视为用户同意本活动规则的修改。</div>
        <div>6.在法律法规允许的范围内，平台有权对本活动规则进行变动或调整，相关变动或调整将公布在活动规则页面上，并于公布时即时生效，用户继续参与活动则视为对前述变动或者调整后的活动规则予以同意。如果用户拒绝上述活动规则的变更或者调整，则可以选择放弃参与变更后的该活动。</div>
        <div>7.如因第三方通过各种不当手段攻击、篡改对平台及本活动进行干扰、破坏、修改或施加其他影响，或系统故障致使卡片获得、转赠或互换发生错误、红包/奖品发放、提现发生错误、领取奖品发生错误、用户无法参与或参与失败的，平台无需为此承担任何法律责任。</div>
        <div>8.活动期间，因用户操作不当或用户所在地区网络故障、支付平台网络故障、电信运营商故障、第三方平台限制等非平台所能控制的原因导致的用户无法参与活动、或参与失败，平台无需为此承担任何法律责任。</div>
        <div>9.请用户务必通过手机官方客户端参与本活动。任何人或第三方以平台的名义宣称或从事类似活动或恶意通知用户中奖、领取红包/卡券或欺诈赠与，造成用户损失的，平台无需为此承担法律责任。未经主办方事先书面许可，用户因参加本活动所取得的权利或获得的奖励均不得转让。</div>
        <div>10.为确保用户能顺利收到实物奖品，主办方将收集、储存和使用获奖用户的收件信息（包括收件人姓名、手机号码及收件地址），以便完成实物奖品的寄送及发放。以上信息由用户自愿提供，用户有权拒绝提供，但如用户不提供相关信息或者提供的信息并非真实有效的信息，用户将无法领取相应的奖品。主办方将严格保护用户的信息安全，采用适当制度、安全技术和程序等措施来保护用户的信息不被未经授权的访问、使用或泄漏。主办方亦将促使本活动规则项下的接收和使用方尽力保护和不予泄露您的信息，主办方将严格要求上述信息接收和使用方（如有）遵循本活动规则谨慎进行数据的使用。如超越上述范围，接收方和/或使用方应另行征得用户的授权同意，若因其未获得用户的授权同意致使用户的合法权益受到侵害的，该信息接收和/或使用方应承担相应的法律责任。</div>
        <div>11.《市值风云用户协议》、《市值风云隐私政策》同样适用于本次活动，本次活动规则及相关条款与《市值风云用户协议》、《市值风云隐私政策》相冲突的，以本次活动规则及相关条款为准。本次活动规则及相关条款未约定的内容，仍以《市值风云用户协议》、《市值风云隐私政策》为准。</div>
        <div>12.如果你在活动中遇到任何问题，请在市值风云APP - 【我的】-【客服】中将问题反馈给我们。</div>
        <div>13.本活动与Apple Inc无关。</div>
      </div>
    </Container>
  )
}

export default Activity230Rules;

const Container = styled.div`
  height: 100vh;
  font-size: 16px;
  line-height: 24px;
  box-sizing: border-box;
  padding-top: 44px;
  .content {
    padding: 0 16px;
  }
  .title {
    font-weight: 500;
    color: #FF4050;
    padding: 14px 0;
    font-size: 20px;
  }
  .date {
    font-size: 14px;
    font-weight: 500;
    margin: 10px 0;
  }
  .sub-title {
    font-weight: 500;
    padding: 10px 0;
    font-size: 18px;
  }
`


// WEBPACK FOOTER //
// ./src/views/activity_230/rule.js